export enum ButtonType {
  small_button_fill = 'small_button_fill',
  medium_button_fill = 'medium_button_fill',
  big_button_fill = 'big_button_fill',
  small_button_stroke = 'small_button_stroke',
  medium_button_stroke = 'medium_button_stroke',
  big_button_stroke = 'big_button_stroke',
  link_blue = 'link_blue',
}
export enum Status {
  ready = 'ready',
  loading = 'loading',
  loaded = 'loaded',
}


// WEBPACK FOOTER //
// ./src/uikit/components/AppButtonNew/defaultConfigs.ts